import { TvQuoteSubscriptionItem } from '../Containers/TvQuoteSubscriptionItem';
import { TvQuoteSubscriptionsContainer } from '../Containers/TvQuoteSubscriptionsContainer';
export class TvQuoteManager {
    constructor() {
        this.subscriptionContainer = new TvQuoteSubscriptionsContainer();
    }
    getQuotes(symbols, onDataCallback, onErrorCallback) {
        setTimeout(() => {
            const data = TvQuoteSubscriptionItem.getQuoteDataArray(symbols, this.curAccount);
            onDataCallback(data);
        }, 0);
    }
    subscribeQuotes(symbols, fastSymbols, onRealtimeCallback, listenerGUID) {
        this.subscriptionContainer.subscribeQuotes(symbols, fastSymbols, onRealtimeCallback, listenerGUID);
    }
    unsubscribeQuotes(listenerGUID) {
        this.subscriptionContainer.unsubscribeQuotes(listenerGUID);
    }
    setCurrentAccount(account) {
        this.curAccount = account;
        this.subscriptionContainer.changeCurrentAccount();
    }
}
